import { LayoutObject } from '../../types/types';

// Keeps an object's geometry inside the canvas bounds.
export const clampObjectToCanvas = (
  object: LayoutObject,
  canvasWidth: number,
  canvasHeight: number
): LayoutObject => {
  const width = Math.min(object.width ?? 0, canvasWidth);
  const height = Math.min(object.height ?? 0, canvasHeight);
  const x = Math.min(Math.max(object.x ?? 0, 0), canvasWidth - width);
  const y = Math.min(Math.max(object.y ?? 0, 0), canvasHeight - height);

  return { ...object, x, y, width, height };
};
